import { createSlice } from '@reduxjs/toolkit'
import { getActiveFilters } from 'utils/helpers'

const initialState = {
  activeFilters: [] as string[],
  tableFilters: {
    search: '',
    group: '',
    course: '',
    status: '',
    start_date_from: '',
    start_date_to: '',
    session: '',
  },
  sessionBackUrl: null,
}

export const sessionsUI = createSlice({
  name: 'sessionsUI',
  initialState: initialState,
  reducers: {
    setSearch: (state, { payload }) => {
      state.tableFilters.search = payload
    },
    setGroup: (state, { payload }) => {
      state.tableFilters.group = payload
    },
    setCourse: (state, { payload }) => {
      state.tableFilters.course = payload
    },
    setStatus: (state, { payload }) => {
      state.tableFilters.status = payload
    },
    setStartDatetimeFromDate: (state, { payload }) => {
      state.tableFilters.start_date_from = payload
    },
    setStartDatetimeToDate: (state, { payload }) => {
      state.tableFilters.start_date_to = payload
    },
    setSession: (state, { payload }) => {
      state.tableFilters.session = payload
    },
    setSessionBackUrl: (state, { payload }) => {
      state.sessionBackUrl = payload
    },
    trackActiveFilters: (state: any) => {
      state.activeFilters = getActiveFilters(initialState.tableFilters, state)
    },
    clearAllFilters: (state: any) => {
      state.tableFilters = initialState.tableFilters
      state.activeFilters = []
    },
  },
})

export const {
  setSearch,
  setGroup,
  setCourse,
  setStatus,
  setStartDatetimeFromDate,
  setStartDatetimeToDate,
  setSession,
  trackActiveFilters,
  clearAllFilters,
  setSessionBackUrl,
} = sessionsUI.actions

export default sessionsUI.reducer
